import React from 'react';
import { telemedicineConsent } from '../data/mock';
import { Video, Shield, Clock, Globe } from 'lucide-react';

const Telemedicine = () => {
  const benefits = [
    {
      icon: Video,
      title: 'Secure Consultations',
      description: 'GDPR-compliant, fully confidential video and audio consultations'
    },
    {
      icon: Clock,
      title: 'Convenient Access',
      description: 'Medical care from anywhere, on your schedule'
    },
    {
      icon: Globe,
      title: 'International Care',
      description: 'Ideal for travelers and expatriates'
    },
    {
      icon: Shield,
      title: 'Privacy Protected',
      description: 'Your health information remains confidential'
    }
  ];

  return (
    <section id="telemedicine" className="section-padding bg-[#0f172a]">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Content */}
          <div>
            <p className="text-sm uppercase tracking-widest text-[#b8860b] font-medium mb-4">
              Remote Care
            </p>
            <h2 className="heading-1 text-white mb-6">
              Telemedicine Services
            </h2>
            <p className="body-large text-[#94a3b8] mb-8">
              {telemedicineConsent.intro}
            </p>

            {/* Benefits Grid */}
            <div className="grid sm:grid-cols-2 gap-6 mb-10">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-11 h-11 border-2 border-[#b8860b] flex items-center justify-center flex-shrink-0">
                    <benefit.icon size={20} className="text-[#b8860b]" />
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-white mb-1">
                      {benefit.title}
                    </h4>
                    <p className="text-sm text-[#94a3b8]">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 bg-[#b8860b] text-white font-medium hover:bg-[#996f0a] transition-colors">
              Schedule Telemedicine Consultation
            </a>
          </div>

          {/* Right Content - Consent Info */}
          <div className="bg-white p-8 lg:p-10">
            <h3 className="heading-3 text-[#0f172a] mb-6">
              {telemedicineConsent.title}
            </h3>
            
            <div className="space-y-4 mb-8">
              <p className="text-xs uppercase tracking-wider text-[#64748b] mb-3">
                By participating, you acknowledge:
              </p>
              {telemedicineConsent.acknowledgments.slice(0, 4).map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="w-6 h-6 bg-[#0f172a] text-white flex items-center justify-center text-xs font-medium flex-shrink-0 mt-0.5">
                    {index + 1}
                  </span>
                  <p className="text-sm text-[#475569] leading-relaxed">
                    {item}
                  </p>
                </div>
              ))}
            </div>

            <div className="border-t border-[#e2e8f0] pt-6">
              <p className="text-xs uppercase tracking-wider text-[#64748b] mb-3">
                By proceeding, you confirm:
              </p>
              <ul className="space-y-2">
                {telemedicineConsent.confirmations.map((item, index) => (
                  <li key={index} className="text-sm text-[#475569] flex items-start gap-2">
                    <span className="text-[#b8860b] font-bold">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Telemedicine;
